module.exports = __webpack_public_path__ + "static/media/BG_Tentang_Kami.5b81ce38.jpg";